import type { GlobalStylesProps } from '@mui/material/GlobalStyles';
import theme, { createStyles } from 'core/utilities/theme';

const printColors = {
  border: '#161413',
  rowOdd: '#F6F5F4',
  rowEven: '#E3E0DE',
};

// TODO: missing typing
const styles = {
  table: {
    marginBottom: theme.spacing(3),
    '& tr:nth-of-type(odd) td:first-of-type, tr:nth-of-type(odd) td:last-of-type': {
      backgroundColor: printColors.rowOdd,
    },
    '& tr:nth-of-type(even) td:first-of-type, tr:nth-of-type(even) td:last-of-type': {
      backgroundColor: printColors.rowEven,
    },
  },
  row: {
    // Avoid page break within a table row
    breakInside: 'avoid',
  },
  cell: {
    padding: '1px 4px',
    border: `1px solid ${printColors.border}`,
    '&.darkBg': {
      color: 'white',
    },
    '&.lightBg': {
      color: theme.palette.text.primary,
    },
  },
  nameCell: {
    width: '160px',
    maxWidth: '160px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  residuesCell: {
    padding: 0,
  },
  positionCell: {
    width: '35px',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  pagebreak: {
    // Works on Chrome, not FF. We use height="100vh" in PrintViewSummary for FF.
    breakAfter: 'page',
  },
};

export const pagePrintStyles: GlobalStylesProps['styles'] = {
  // Must be outside '@media print' to work in Firefox
  '@page': {
    size: 'A4',
    // 6.35mm seems to be the minimum all printers should be able to handle
    // https://stackoverflow.com/a/3513476
    // 8mm will remove the header from the print preview
    // We want to keep the footer to get the page count
    margin: '8mm 10mm 10mm 10mm',
  },
  '@media print': {
    body: {
      // Enable print colors (background, border etc.)
      WebkitPrintColorAdjust: 'exact',
      // FF fix, otherwise it will just render the first page
      overflow: 'visible !important',
    },
    'html, body': {
      width: '210mm',
      height: '297mm',
    },
  },
};

export default createStyles({
  root: {
    margin: '0 auto',
    width: '210mm', // A4 size
    backgroundColor: 'white',
  },
  ...styles,
  media: {
    print: {
      root: {
        margin: 0,
      },
      ...styles,
    },
  },
});
